import { Translation } from 'cng-common/features/translations/components/translation'
import { ITableColumn } from 'partner360/components/financialTable'
import styles from 'partner360/components/QBR/components/qbrDocumentDetails/components/steps/sobAchievement/SobAchievement.module.scss'
import { TRANSLATION_KEYS } from 'partner360/components/QBR/translations'
import { IQBRSobAchievement } from 'partner360/models/qbr/IQBRSobAchievement'

import { QbrQuarters } from '../../../../../../models/qbrQuarters'

import { getSobAchievementShortedCell } from './getSobAchievementShortedCell'

interface IGetSobAchievementShortedColumnsParameters {
  currentFYear: number
  selectedPeriodFQuarters: number[]
}

export const getSobAchievementShortedColumns = ({
  currentFYear,
  selectedPeriodFQuarters,
}: IGetSobAchievementShortedColumnsParameters): ITableColumn<IQBRSobAchievement>[] => {
  const previousFYear = currentFYear - 1
  const previousFYearLastTwoDigits = previousFYear.toString().slice(-2)

  const previousYearColumns: ITableColumn<IQBRSobAchievement>[] = [
    {
      key: 'name',
      title: 'Name',
      renderFn: () => {
        return (
          <div className={styles.financialValueShortedView}>
            <p className={styles.paragraph}>
              <Translation text={TRANSLATION_KEYS.financialTable.yoyActual} />
            </p>
            <p className={styles.paragraph}>
              <Translation text={TRANSLATION_KEYS.financialTable.yoyPlan} />
            </p>
            <p className={styles.paragraph}>
              <Translation text={TRANSLATION_KEYS.financialTable.yoySob} />
            </p>
          </div>
        )
      },
    },
    {
      key: `${previousFYear} Q1`,
      title: `Q1'${previousFYearLastTwoDigits}`,
      renderFn: (item) => {
        return getSobAchievementShortedCell({
          actuals: item.PrevYearQ1Actuals,
          plans: item.PrevYearQ1Plans,
          yoyActuals: item.PrevYearQ1YoYActuals,
        })
      },
    },
    {
      key: `${previousFYear} Q2`,
      title: `Q2'${previousFYearLastTwoDigits}`,
      renderFn: (item) => {
        return getSobAchievementShortedCell({
          actuals: item.PrevYearQ2Actuals,
          plans: item.PrevYearQ2Plans,
          yoyActuals: item.PrevYearQ2YoYActuals,
        })
      },
    },
    {
      key: `${previousFYear} Q3`,
      title: `Q3'${previousFYearLastTwoDigits}`,
      renderFn: (item) => {
        return getSobAchievementShortedCell({
          actuals: item.PrevYearQ3Actuals,
          plans: item.PrevYearQ3Plans,
          yoyActuals: item.PrevYearQ3YoYActuals,
        })
      },
    },
    {
      key: `${previousFYear} Q4`,
      title: `Q4'${previousFYearLastTwoDigits}`,
      renderFn: (item) => {
        return getSobAchievementShortedCell({
          actuals: item.PrevYearQ4Actuals,
          plans: item.PrevYearQ4Plans,
          yoyActuals: item.PrevYearQ4YoYActuals,
        })
      },
    },
  ]
  const currentYearColumns: ITableColumn<IQBRSobAchievement>[] = []
  const currentFYearLastTwoDigits = currentFYear.toString().slice(-2)

  if (selectedPeriodFQuarters.includes(QbrQuarters.Q1)) {
    currentYearColumns.push({
      key: `${currentFYear} Q1`,
      title: `Q1'${currentFYearLastTwoDigits}`,
      renderFn: (item) => {
        return getSobAchievementShortedCell({
          actuals: item.CurrentYearQ1Actuals,
          plans: item.CurrentYearQ1Plans,
          yoyActuals: item.CurrentYearQ1YoYActuals,
        })
      },
    })
  }

  if (selectedPeriodFQuarters.includes(QbrQuarters.Q2)) {
    currentYearColumns.push({
      key: `${currentFYear} Q2`,
      title: `Q2'${currentFYearLastTwoDigits}`,
      renderFn: (item) => {
        return getSobAchievementShortedCell({
          actuals: item.CurrentYearQ2Actuals,
          plans: item.CurrentYearQ2Plans,
          yoyActuals: item.CurrentYearQ2YoYActuals,
        })
      },
    })
  }

  if (selectedPeriodFQuarters.includes(QbrQuarters.Q3)) {
    currentYearColumns.push({
      key: `${currentFYear} Q3`,
      title: `Q3'${currentFYearLastTwoDigits}`,
      renderFn: (item) => {
        return getSobAchievementShortedCell({
          actuals: item.CurrentYearQ3Actuals,
          plans: item.CurrentYearQ3Plans,
          yoyActuals: item.CurrentYearQ3YoYActuals,
        })
      },
    })
  }

  if (selectedPeriodFQuarters.includes(QbrQuarters.Q4)) {
    currentYearColumns.push({
      key: `${currentFYear} Q4`,
      title: `Q4'${currentFYearLastTwoDigits}`,
      renderFn: (item) => {
        return getSobAchievementShortedCell({
          actuals: item.CurrentYearQ4Actuals,
          plans: item.CurrentYearQ4Plans,
          yoyActuals: item.CurrentYearQ4YoYActuals,
        })
      },
    })
  }

  return [...previousYearColumns, ...currentYearColumns]
}
